import { render, staticRenderFns } from "./ProfileGames.vue?vue&type=template&id=126b5c26&scoped=true"
import script from "./ProfileGames.vue?vue&type=script&lang=js"
export * from "./ProfileGames.vue?vue&type=script&lang=js"
import style0 from "./ProfileGames.vue?vue&type=style&index=0&id=126b5c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b5c26",
  null
  
)

export default component.exports